import { render, staticRenderFns } from "./commontop.vue?vue&type=template&id=d53a622c&"
import script from "./commontop.vue?vue&type=script&lang=js&"
export * from "./commontop.vue?vue&type=script&lang=js&"
import style0 from "./commontop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports